import React from 'react';

const isText = (value) => typeof value === 'string' && value.trim().length > 0;

const Marquee = (props) => {
  const { text, speed, variant } = props;

  if (!isText(text)) return null;

  const label = text.trim();
  const items = Array.from({ length: 12 }, (_, index) => (
    <span key={index} className="hkx-marquee__item" aria-hidden={index !== 0}>
      {label}
    </span>
  ));

  const trackStyle = isText(speed) ? { animationDuration: speed } : undefined;
  const className = isText(variant) ? `hkx-marquee hkx-marquee--${variant.trim()}` : 'hkx-marquee';

  return (
    <div className={className}>
      <div className="hkx-marquee__track" style={trackStyle}>
        {items}
        {items}
      </div>
    </div>
  );
};

export default Marquee;
